"use client";

import { createContext, useContext } from "react";

// Authentication stays in the application shell; feature state is scoped to it.
export const MistakeReviewIdentity = createContext<string | undefined>(
  undefined,
);
export const useMistakeReviewIdentity = () => useContext(MistakeReviewIdentity);
